/**
 * The `Api.ApiSchema` each API server has named in its responses
 * (`X-LN2-Schema`), by base URL.
 *
 * A server that names its schema was built with schema discovery, so it also
 * accepts the header on a request. A server that never has may be older, and is
 * never sent it: its CORS preflight refuses a request header it does not know,
 * which would fail every request this bundle makes.
 */

import { isSchemaHash, SCHEMA_HEADER } from "../schemaHeaders";
import { API_SCHEMA_HASH } from "../schemaHashes";

const named = new Map<string, string>();

/**
 * The schema a response names in `X-LN2-Schema`, in lower case, or null when it
 * names none or the value is not a SHA-256.
 */
export function responseSchema(response: Response): string | null {
  const value = response.headers.get(SCHEMA_HEADER)?.toLowerCase() ?? "";
  return isSchemaHash(value) ? value : null;
}

/** Records the schema a response from the server at `baseUrl` named, if any. */
export function noteServerSchema(baseUrl: string, schemaHash: string | null): void {
  if (schemaHash) {
    named.set(baseUrl, schemaHash);
  }
}

/** The schema the server at `baseUrl` last named, or undefined if it never has. */
export function serverSchema(baseUrl: string): string | undefined {
  return named.get(baseUrl);
}

/**
 * The headers that name this bundle's API schema to the server at `baseUrl`:
 * none until that server has named its own.
 */
export function schemaRequestHeaders(baseUrl: string): Record<string, string> {
  return serverSchema(baseUrl) === undefined ? {} : { [SCHEMA_HEADER]: API_SCHEMA_HASH };
}

/** Forgets every server's schema (for tests). */
export function resetServerSchemas(): void {
  named.clear();
}
